import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-auction',
  templateUrl: './our-auction.component.html',
  styleUrls: ['./our-auction.component.scss']
})
export class OurAuctionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
